import React from "react";
import { Quote, Star } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { TESTIMONIALS } from "@/i18n";

export const Testimonials = () => {
  const { lang, t } = useLang();
  const list = [...TESTIMONIALS, ...TESTIMONIALS]; // duplicate for marquee loop

  return (
    <section
      id="testimonials"
      className="py-24 md:py-32 bg-white overflow-hidden"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl">
          <span className="inline-block text-xs uppercase tracking-[0.25em] font-semibold text-green-700">
            {t.testimonials.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
            {t.testimonials.title}
          </h2>
        </div>
      </div>

      <div className="relative mt-14">
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
        <div className="flex gap-6 animate-marquee w-max">
          {list.map((tst, i) => {
            const it = tst[lang];
            return (
              <article
                key={`${it.name}-${i}`}
                className="w-[340px] sm:w-[380px] flex-none rounded-3xl bg-green-50/40 border border-green-100 p-7 shadow-sm"
                data-testid={`testimonial-card-${i}`}
              >
                <Quote className="h-7 w-7 text-green-600/40" />
                <p className="mt-3 text-slate-700 leading-relaxed text-base">"{it.text}"</p>
                <div className="mt-5 flex items-center justify-between">
                  <div>
                    <p className="font-display font-semibold text-slate-900 text-sm">{it.name}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{it.role}</p>
                  </div>
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: 5 }).map((_, k) => (
                      <Star key={`${it.name}-star-${k}`} className="h-3.5 w-3.5 text-green-600 fill-green-600" />
                    ))}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
